import React from 'react';
import { WorkersHeader } from '../components/WorkersHeader';
import { WorkersTable } from '../components/WorkersTable';
import { ProjectFilterPills } from '../components/ProjectFilterPills';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
export function WorkersPage() {
  const {
    selectedProjects
  } = useProjectFilter();
  const getProjectDisplayText = () => {
    if (selectedProjects.length === AVAILABLE_PROJECTS.length) {
      return 'All Sites';
    }
    if (selectedProjects.length === 1) {
      return selectedProjects[0];
    }
    return `${selectedProjects.length} Sites`;
  };
  return <div className="min-h-screen bg-[#fafafa] font-sans relative" data-id="element-4533">
      <main className="p-6 max-w-[1600px] mx-auto pb-24" data-id="element-4534">
        <div className="mb-6" data-id="element-4535">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4 transition-colors" data-id="element-4536">
            <ArrowLeft size={16} data-id="element-4537" />
            Back to Dashboard
          </Link>
          <div className="flex items-center gap-2" data-id="element-4538">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-4539">Workers</h1>
            <span className="text-gray-400 text-2xl" data-id="element-4540">·</span>
            <span className="text-gray-600 text-xl" data-id="element-4541">
              {getProjectDisplayText()}
            </span>
          </div>
          <ProjectFilterPills data-id="element-4542" />
        </div>

        <WorkersHeader data-id="element-4543" />
        <WorkersTable data-id="element-4544" />
      </main>
    </div>;
}